import React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom';
import { ChevronLeft, Users, Blocks, Globe2 } from 'lucide-react';

const ADMIN_CARDS = [
    { key: "users", title: "Users", desc: "View, edit, and remove accounts.", icon: Users, to: "/admin/users" },
    { key: "apps", title: "Apps", desc: "Manage apps and maintenance mode.", icon: Blocks, to: "/admin/apps" },
    { key: "restrictions", title: "Restricted Areas", desc: "Block countries or regions.", icon: Globe2, to: "/admin/restrictions" },
];

const AdminHub = () => {
    const navigate = useNavigate();
    const { role } = useOutletContext() || {};

    return (
        <div className="page">
            <div className="page_header">
                <button className="back" onClick={() => navigate("/")}><ChevronLeft /></button>
                <div className="page_title">
                    <h2>Admin</h2>
                    <p>Manage users, apps, and access restrictions.</p>
                </div>
            </div>

            <div className="page_body">
                {role === "viewer" ? (
                    <div className="viewer_note">You're signed in as a viewer — you can browse everything here, but editing and deleting is admin-only.</div>
                ) : null}

                <div className="admin_hub">
                    {ADMIN_CARDS.map(card => {
                        const Icon = card.icon;
                        return (
                            <button className="nav_card" key={card.key} onClick={() => navigate(card.to)}>
                                <div className="nav_card_icon"><Icon size="22" /></div>
                                <div className="nav_card_text">
                                    <h3>{card.title}</h3>
                                    <p>{card.desc}</p>
                                </div>
                            </button>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default AdminHub;
